/** Human-readable labels for bond data-correction field names. */
export const CORRECTION_FIELD_LABELS = {
  bond_amount: "Bond Amount",
  bond_number: "Bond Number",
  bond_sub_category: "Bond Sub Category",
  premium: "Premium",
  court_case_number: "Court Case Number",
  state: "State",
  county: "County",
  name: "Name",
  first_document_name: "First Document Name",
  second_document_name: "Second Document Name",
  third_document_name: "Third Document Name",
  requester_name: "Requester Name",
  requester_user_email: "Requester Email",
  requester_phone_number: "Requester Phone",
  is_underwriting: "Is Underwriting",
  managing_lawfirm: "Managing Law Firm",
  law_firm: "Law Firm",
  law_firm_location: "Law Firm Location",
  obligee: "Obligee",
  bond_carrier: "Bond Carrier",
  bond_type: "Bond Type",
  status: "Status",
  billing_method: "Billing Method",
};

export const formatCorrectionFieldLabel = (field) => {
  const key = (field ?? "").toString().trim().toLowerCase().replace(/\s+/g, "_");
  if (!key) return "—";
  if (CORRECTION_FIELD_LABELS[key]) return CORRECTION_FIELD_LABELS[key];
  return key
    .split("_")
    .map((w) => (w ? w.charAt(0).toUpperCase() + w.slice(1).toLowerCase() : ""))
    .join(" ");
};

/** Format correction From/To for display: bond_amount uses US style with commas, no decimals. */
export const formatCorrectionFromTo = (field, value) => {
  const f = (field ?? "").toString().toLowerCase().replace(/\s+/g, "_");
  if (f === "bond_amount") {
    const n = Number(value);
    return Number.isNaN(n)
      ? (value ?? "").toString()
      : n.toLocaleString("en-US", { maximumFractionDigits: 0, minimumFractionDigits: 0 });
  }
  return (value ?? "").toString();
};
